import styled from "styled-components"

import {h6} from "@irati/ui/src/Typography/Heading/styles"

export const Text = styled.text`
  ${h6}
  fill: ${({theme}) => theme.colors.primary1};
`
